import type { PublicationCode } from '@/scopes/common/domain/models'
import { mqMax, mqMin, tok } from '@sunwebgroup/ui-components'
import { Skeleton, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { use } from 'react'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { CatalogueDetailsContext } from '@/scopes/common/components/CatalogueDetailsContext'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import { getCatalogueTypeByPublicationCode } from '@/scopes/common/domain/functions/catalogues'
import { useResults } from '@/scopes/search/search/domain/hooks'

interface ResultsCounterProps {
  isLoading?: boolean
}

const Wrapper = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};
`

const ResultsTextMobile = styled(Typography)`
  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: none;
  }
`
const ResultsTextOtherBreakPoint = styled(Typography)`
  @media ${mqMax('primitives_breakpoint_s_max')} {
    display: none;
  }
`

export function ResultsCounter({ isLoading }: ResultsCounterProps) {
  const intl = useIntl()
  const { totalResults } = useResults()
  const { publicationCode } = use(CatalogueDetailsContext)
  const accoType = getCatalogueTypeByPublicationCode(publicationCode as PublicationCode)
  const resultsCounterTitleKey = accoType === CatalogueType.Summer ? 'search_results_sun' : 'search_results_ski'
  if (isLoading) {
    return <Skeleton />
  }

  // TODO duplicated breakpoint for mobile and for the rest of breakpoints due to search_results_sun includes
  // the number in the translation. After being migrated to UDS. The translation should be changed to don't have the number and then
  // always show the number and have another typography where search_results_sun is hide when breakpoint is mobile
  return (
    <Wrapper data-qa="total-results">
      <ResultsTextOtherBreakPoint variant="body-m-bold-tight">{intl.formatMessage({ id: resultsCounterTitleKey }, { nrOfResults: totalResults })}</ResultsTextOtherBreakPoint>
      <ResultsTextMobile variant="body-m-bold-tight">{totalResults}</ResultsTextMobile>
    </Wrapper>
  )
}
